var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLuna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.55 37.1C28.7949 37.1 37.1 28.7949 37.1 18.55C37.1 8.30512 28.7949 0 18.55 0C8.30512 0 0 8.30512 0 18.55C0 28.7949 8.30512 37.1 18.55 37.1Z",
    fill: "#172852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.942 8.29C17.1142 7.47751 19.5591 7.47565 21.7721 8.14345C24.6529 9.03756 27.0848 11.2116 28.3555 13.9403C28.7061 14.7176 29.0419 15.5282 29.0753 16.3926C27.4558 15.454 25.6806 14.8456 23.9017 14.2909C21.0561 13.2651 18.077 12.5528 15.3835 11.143C14.7565 10.7683 13.957 10.3843 13.7864 9.60334C13.7177 8.92812 14.4319 8.55155 14.942 8.29Z",
    fill: "#FFD83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38459 14.8567C9.01343 13.1501 10.0448 11.5659 11.4453 10.3917C11.8015 13.3208 13.048 16.1515 15.1071 18.2811C17.5761 20.8465 21.0932 22.4214 24.6714 22.3621C26.0924 22.4066 27.4817 22.0783 28.8674 21.813C27.504 26.7399 22.1041 30.0103 17.1012 29.2238C14.0813 28.8379 11.2932 27.0497 9.61074 24.525C7.71308 21.7351 7.2345 18.0306 8.38459 14.8567Z",
    fill: "#FFD83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9017 14.2909C25.6806 14.8455 27.4558 15.454 29.0752 16.3926L29.1847 16.4501C29.3349 17.5798 29.4444 18.7318 29.244 19.8633C28.4297 19.5183 27.7693 18.9117 27.0793 18.3756C25.7511 17.27 24.3951 16.0049 23.9017 14.2909Z",
    fill: "#FF6F03"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.1,
    height: 37.1,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuna);
export default __webpack_public_path__ + "static/media/luna.63d1010b7b5a00d409ad50688bb03fac.svg";
export { ForwardRef as ReactComponent };